import React from 'react';
import { Link } from 'components';
import './styles.scss';

const NavigationLinks = props => {
  const { items } = props;
  if (!items) return null;
  return (
    <div className="footer-links">
      <div className="footer-links-container">
        {items.map(item => {
          const { submenu_label: submenuLabel, submenu_link: submenuLink } = item;
          if (!submenuLink?.uid) return null;
          return (
            <Link key={submenuLabel?.text} className="footer-link" to={submenuLink?.url}>
              {submenuLabel?.text}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default NavigationLinks;
